import { render, staticRenderFns } from "./CreateSettingTax.vue?vue&type=template&id=c71df028"
import script from "./CreateSettingTax.vue?vue&type=script&lang=js"
export * from "./CreateSettingTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports